// External dependencies
import React from 'react';
import { Icon, Text } from 'atomize';

// Local dependencies
import { FormattedMessage } from 'gatsby-plugin-react-intl';
import DateTime from '../common/DateTime';
import {
  Column,
  Sections,
  Specification,
} from './createConsigneeGoodsSpecifications/redux/types';
import { ConsigneeGoodSpecifications } from './types';
import { EMPTY } from './createConsigneeGoodsSpecifications/create-consignee-good-specifications';

export enum ConsigneesPath {
  CREATE = '/goods-specifications/create-good-specification/',
  LIST = '/goods-specifications/'
}

export const fields = [
  {
    field: (goodsSpecifications: ConsigneeGoodSpecifications) => (
      <DateTime date={goodsSpecifications.createdDate} />
    ),
    title: <FormattedMessage id="createdDate" />,
  },
  {
    field: (goodsSpecifications: ConsigneeGoodSpecifications) => (
      <a href={goodsSpecifications.exportFile?.url} download>
        Скачать
      </a>
    ),
    title: <FormattedMessage id="groupedFile" />,
  },
  {
    field: (goodsSpecifications: ConsigneeGoodSpecifications) =>
      goodsSpecifications.exportFile?.linesCount,
    title: <FormattedMessage id="goupedFileLinesCount" />,
  },
  {
    field: (goodsSpecifications: ConsigneeGoodSpecifications) => (
      <a href={goodsSpecifications.sourceFile?.url} download>
        Скачать
      </a>
    ),
    title: <FormattedMessage id="sourceFile" />,
  },
  {
    field: (goodsSpecifications: ConsigneeGoodSpecifications) =>
      goodsSpecifications.sourceFile?.linesCount,
    title: <FormattedMessage id="sourceFileLinesCount" />,
  },
  {
    field: (goodsSpecifications: ConsigneeGoodSpecifications) =>
      goodsSpecifications?.consigneeProfile?.name,
    title: <FormattedMessage id="consigneeName" />,
  },
];

export function getTopBar(loading: boolean, total: number) {
  return (
    <Text
      textColor="table_cell_text_color"
      textSize={{ xs: 'mobileTitle', md: 'title' }}
      textWeight="700"
    >
      <FormattedMessage id="GoodsSpecifications" />
      {loading ? (
        <Icon m="0 .62rem" name="Loading3" size="20px" />
      ) : (
        ` (${total})`
      )}
    </Text>
  );
}

export function initColumnNameToSections(column: Column, sections: Sections) {
  const { columnName, fileName } = column;

  const result = sections.map((section) => {
    if (section.name === fileName) {
      section.values.push(columnName);
    }

    return section;
  });

  return result;
}

export function getSection(fileName: string, sections: Sections) {
  let sectionIndex;

  const section = sections.find((section, index) => {
    sectionIndex = index;

    return section.name === fileName;
  });

  return { section, sectionIndex: section ? sectionIndex : -1 };
}

export function getMaxNumber(arr: number[]) {
  const maxNumber = Math.max(...arr);

  return maxNumber;
}

export function prepareRows(columns: Column[]) {
  const valuesLengths = columns.map((column) => column.values?.length || 0);
  const maxValuesLength = getMaxNumber(valuesLengths);

  const rows = [];
  const group = new Set();
  const sum = new Set();

  for (let i = 0; i < maxValuesLength; i++) {
    const row = {};

    for (let column of columns) {
      const { columnName, values, specification } = column;
      const field = values[i] || EMPTY;

      if (specification === Specification.GROUP) {
        group.add(columnName);
      }

      if (specification === Specification.SUM) {
        sum.add(columnName);
      }

      row[columnName] = field;
    }

    rows.push(row);
  }

  return {
    rows,
    columnsToGroup: Array.from(group.values()),
    columnsToSum: Array.from(sum.values()),
  };
}
